import { useTypedParams } from '@sorare/routing';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';

import { InventoryRevealableCardsTypeSearchPage } from '@sorare/gameplay/src/pages/inventory/InventoryRevealableCardsTypeSearchPage';

import { PageParams } from './__generated__/routeParams';

const NBAInventoryRevealableCardsTypeSearchPage = () => {
  const { type } = useTypedParams<PageParams>();
  return <InventoryRevealableCardsTypeSearchPage type={type as Rarity} />;
};

export default NBAInventoryRevealableCardsTypeSearchPage;
